// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://lfwyqlaptpylqywcbzxw.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imxmd3lxbGFwdHB5bHF5d2Nienh3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzU5OTAxMTcsImV4cCI6MjA1MTU2NjExN30.eb88IxIcPw9DF7xKObtWx_sPnVoZpM9XJdS0Y6AgXjo";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);